import { PropertyValueSet } from "@genesys/property";

export const initialNewProperties = PropertyValueSet.fromString(
  "airsource=1;voltage=400350;humidityoption=0;newexternalmixing=0"
);
